$(document).on('click', '.sidebar__nav h4.nav-toggle', function(event) {
  event.preventDefault();
  $(this).toggleClass('active--parent');
});
